EXIF = require('exif-js')

FormFileReaderService = ($q ,$window)->
  formFileReaderService = this
  FileReader = $window.FileReader

  formFileReaderService.readAsDataURL = (file) ->
    delay = $q.defer()
    reader = new FileReader()
    reader.onload = ->
      delay.resolve reader.result
    reader.onerror = ->
      delay.reject reader.error

    reader.readAsDataURL(file)
    delay.promise

  formFileReaderService.resetOrientation = (srcBase64, srcOrientation, callback) ->
    img = new Image

    img.onload = ->
      width = img.width
      height = img.height
      canvas = document.createElement('canvas')
      ctx = canvas.getContext('2d')
      # set proper canvas dimensions before transform & export
      if 4 < srcOrientation and srcOrientation < 9
        canvas.width = height
        canvas.height = width
      else
        canvas.width = width
        canvas.height = height
      # transform context before drawing image
      switch srcOrientation
        when 2
          ctx.transform -1, 0, 0, 1, width, 0
        when 3
          ctx.transform -1, 0, 0, -1, width, height
        when 4
          ctx.transform 1, 0, 0, -1, 0, height
        when 5
          ctx.transform 0, 1, 1, 0, 0, 0
        when 6
          ctx.transform 0, 1, -1, 0, height, 0
        when 7
          ctx.transform 0, -1, -1, 0, height, width
        when 8
          ctx.transform 0, -1, 1, 0, 0, width
        else
          break
      # draw image
      ctx.drawImage img, 0, 0
      # export base64
      callback canvas.toDataURL()

    img.src = srcBase64

  formFileReaderService.loadImageOrientation = (imgClass, file) ->
    return unless file
    delay = $q.defer()

    formFileReaderService.readAsDataURL(file).then (base64Image) ->
      $(img).attr 'src', base64Image
      img = $("img.#{imgClass}").get(0)
      EXIF.getData file, ->
        allMetaData = EXIF.getAllTags(file)
        if allMetaData.Orientation
          formFileReaderService.resetOrientation base64Image, allMetaData.Orientation, (resetBase64Image) ->
            # Update an image tag with loaded image source
            $(img).attr 'src', resetBase64Image
            result =
              base64Data: resetBase64Image
              orientation: allMetaData.Orientation
            delay.resolve result
        else
          $(img).attr 'src', base64Image
          result =
            base64Data: base64Image
          delay.resolve result
    delay.promise

  formFileReaderService.base64ImageToBlob = (str) ->
    # extract content type and base64 payload from original string
    pos = str.indexOf(';base64,')
    type = str.substring(5, pos)
    b64 = str.substr(pos + 8)
    # decode base64
    imageContent = atob(b64)
    # create an ArrayBuffer and a view (as unsigned 8-bit)
    buffer = new ArrayBuffer(imageContent.length)
    view = new Uint8Array(buffer)
    # fill the view, using the decoded base64
    n = 0
    while n < imageContent.length
      view[n] = imageContent.charCodeAt(n)
      n++
    # convert ArrayBuffer to Blob
    blob = new Blob([ buffer ], type: type)
    blob

  return formFileReaderService

FormFileReaderService.$inject = [
  '$q'
  '$window'
]

module.exports = FormFileReaderService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/form-file-reader-service.coffee